import { css, html, LitElement, unsafeCSS } from "lit-element";
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

import styles from './style.postcss';
import './fonts.style.css';

const closeIcon = `<svg id="close" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="enable-background:new 0 0 40 40;" viewBox="0 0 40 40" y="0px" x="0px" id="Livello_1" version="1.1"> <path d="M21.7,20l9.8-9.8C32,9.7,32,9,31.5,8.5C31,8,30.3,8,29.8,8.5L20,18.3l-9.8-9.8C9.7,8,9,8,8.5,8.5 C8,9,8,9.7,8.5,10.2l9.8,9.8l-9.8,9.8C8,30.3,8,31,8.5,31.5c0.2,0.2,0.6,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4l9.8-9.8l9.8,9.8 c0.2,0.2,0.6,0.4,0.9,0.4s0.6-0.1,0.9-0.4c0.5-0.5,0.5-1.3,0-1.7L21.7,20z" class="st0"></path></svg>`;
const raiIcon = `<svg id="logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="80" height="80" viewBox="0 0 80 80"><defs><path id="knoj0pgofa" d="M47.02 38.699c-3.219 0-5.102 2.363-5.102 5.137 0 2.876 1.883 5.102 5.103 5.102 3.219 0 5.102-2.226 5.102-5.102 0-2.774-1.849-5.137-5.102-5.137zM17.74 28.425h-.822v8.322h.822c2.774 0 5.924-.548 5.924-4.179 0-3.595-3.15-4.143-5.924-4.143zm7.328 26.78l-8.047-12.842h-.103v12.842H8.356V21.781H21.13c6.507 0 11.404 3.15 11.404 10.274 0 4.623-2.534 8.596-7.192 9.452l10.343 13.698H25.068zm34.727 0h-7.946v-2.534h-.102c-1.405 2.26-4.144 3.288-6.747 3.288-6.61 0-11.301-5.617-11.301-12.158 0-6.506 4.589-12.089 11.198-12.089 2.569 0 5.274.96 6.918 2.98v-2.226h7.945v22.74h.035zm12.02 0H63.87v-22.74h7.945v22.74zm-3.973-26.061c-2.431 0-4.452-2.055-4.452-4.52 0-2.466 2.021-4.521 4.452-4.521 2.432 0 4.453 2.055 4.453 4.52 0 2.466-2.021 4.52-4.453 4.52z"/></defs><g fill="none" fill-rule="evenodd"><g><g transform="translate(-160 -344) translate(160 344)"><use fill="#FFF" fill-rule="nonzero" xlink:href="#knoj0pgofa"/></g></g></g></svg>`;
/**
 * @typedef {null | 'expanding' | 'collapsing' | 'collapsed'} CorporateStatus
 */

export class TopBar extends LitElement {
  // Proprietà privata per bloccare l'aggiornamento di showCorporateMenu dopo l'inizializzazione
  #lockedShowCorporateMenu = false;

  static get styles() {
    return [
      css`${unsafeCSS(styles)}`,
    ];
  }

  static get properties() {
    return {
      collapsed: { type: Boolean },
      fixed: { type: Boolean },
      showMainSiteMenu: { type: Boolean },
      showCorporateMenu: {
        type: Boolean,
        attribute: 'show-corporate-menu',
        converter: {
          fromAttribute: (value) => {
            return value !== 'false';
          }
        }
      }
    }
  }

  _corporateStatus = 'collapsed';
  set corporateStatus(value) {
    const oldValue = this._corporateStatus;
    this._corporateStatus = value;
    this.requestUpdate('corporateStatus', oldValue);
  }
  /**
   * @type {CorporateStatus}
   */
  get corporateStatus() {
    return this._corporateStatus;
  }
  
  get togglerButton() {
    /**
     * @type {HTMLSlotElement}
     */
    const slot = this.renderRoot.querySelector('slot[name="toggler-button"]');
    const nodes = slot.assignedNodes();
    return nodes.length ? nodes[0] : undefined;
  }

  constructor() {
    super();

    this.collapsed = true;
    this.fixed = false;
    this.showMainSiteMenu = true;
    this.showCorporateMenu = true;
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.corporateMenuBar) {
      this.corporateMenuBar.addEventListener('animationend', this._animationHandler);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.corporateMenuBar) {
      this.corporateMenuBar.removeEventListener('animationend', this._animationHandler);
    }
  }

  firstUpdated() {
    super.firstUpdated();
    if (this.corporateMenuBar) {
      this.corporateMenuBar.addEventListener('animationend', this._animationHandler);
    }
  }

  _animationHandler = (e) => {
    if (this.corporateStatus === 'expanding') {
      this.corporateStatus = null;
      if (this.togglerButton && ("corporateStatus" in this.togglerButton)) {
        this.togglerButton.corporateStatus = null;
      }
      const myEvent = new CustomEvent('rai:open-corporate-menu', {
        detail: {
          messaggio: 'Corporate Menu Aperto',
        }
      });
      document.dispatchEvent(myEvent);
    } else if (this.corporateStatus === 'collapsing') {
      this.corporateStatus = 'collapsed';
      if (this.togglerButton && ("corporateStatus" in this.togglerButton)) {
        this.togglerButton.corporateStatus = 'collapsed';
      }
      const myEvent = new CustomEvent('rai:close-corporate-menu', {
        detail: {
          messaggio: 'Corporate Menu Chiuso',
        }
      });
      document.dispatchEvent(myEvent);
    }
  };

  render() {
    return html`
      <div class="top-bar ${!this.showCorporateMenu ? 'top-bar--hide-corporate-menu' : ''} ${this.fixed || !this.collapsed ? 'sticky top-0' : ''}">
        ${this.showCorporateMenu ? this._corporateMenu() : ''}
        ${this.showMainSiteMenu ? html`
          <div class="rai-header">
            <slot name="header"></slot>
          </div>
          ${this.showCorporateMenu ? html`
            <div class="toggle-corporate" @click=${this.toggleCorporateMenu}>
              <slot name="toggler-button">
                <button class="corporate-menu__toggle" aria-label=${this.corporateStatus === 'collapsed' ? 'Apri il menu Rai' : 'Chiudi il menu Rai'}>
                  ${this.corporateStatus === 'collapsed'
                    ? html`
                      ${unsafeHTML(raiIcon)}
                      <div class="toggle__icon"></div>
                    `
                    : html`<div class="close__icon">${unsafeHTML(closeIcon)}</div>`
                  }
                </button>
              </slot>
            </div>
          ` : ''}` : ''}
      </div>
    `;
  }

  _corporateMenu() {
    return html`
      <div class="corporate-menu-bar" id="corporate-menu-bar"
        ?collapsed=${this.corporateStatus === 'collapsed'}
        ?collapsing=${this.corporateStatus === 'collapsing'}
        ?expanding=${this.corporateStatus === 'expanding'}>
        <div class="corporate-menu">
          <a aria-label="Vedi Rai Homepage" href="https://www.rai.it">
            <svg xmlns="//www.w3.org/2000/svg" viewBox="0 0 200 200" class="corporate-menu__logo">
              <g display="inline">
                <path
                  d="m199.960999,0.02613h-199.961259v199.97387h199.961259v-199.97387l0,0zm-159.700298,97.626572h2.007999c6.765999,0 14.394001,-1.250999 14.394001,-9.946999c0,-8.671005 -7.628002,-9.948006 -14.394001,-9.948006h-2.007999v19.895004l0,0zm45.645,44.068291h-25.841l-19.595001,-30.716995h-0.209v30.716995h-20.756001v-79.869293h31.017002c15.789097,0 27.757,7.535004 27.757,24.575996c0,11.030006 -6.153999,20.561302 -17.483002,22.568306l25.110001,32.724991l0,0zm20.691299,-27.104996c0,6.871002 4.551003,12.177002 12.399002,12.177002c7.835999,0 12.386002,-5.306 12.386002,-12.177002c0,-6.675995 -4.550003,-12.281998 -12.386002,-12.281998c-7.848,0 -12.399002,5.606003 -12.399002,12.281998m43.416,27.104996h-19.257004v-6.022995h-0.233994c-3.377007,5.397003 -10.039001,7.822006 -16.415001,7.822006c-16.102203,0 -27.431305,-13.455002 -27.431305,-29.022003c0,-15.567299 11.147003,-28.918304 27.236305,-28.918304c6.231995,0 12.815994,2.334 16.843994,7.106003v-5.292999h19.257004v54.328293l0,0zm32.399002,-75.202293c0,5.945 -4.889008,10.808998 -10.807999,10.808998c-5.919006,0 -10.807999,-4.863998 -10.807999,-10.808998c0,-5.918999 4.888992,-10.782001 10.807999,-10.782001c5.918991,0 10.807999,4.863003 10.807999,10.782001m-1.173004,75.202293h-19.257004v-54.328293h19.257004v54.328293l0,0zm-181.238998,23.27301v-88.318306v-18.617996v-25.202h-0.987l0.987,132.138302z"
                  fill="#fff"
                ></path>
              </g>
            </svg>
          </a>
          <ul
            role="menubar"
            class="corporate-menu__list"
            data-dropdown-menu="dropdown-menu"
          >
            <li role="menuitem" class="corporate-menu__list__item">
              <a tabindex="0" href="https://www.raiplay.it" target="_top" class="corporate-menu__list__item__link">RaiPlay</a>
            </li>
            <li role="menuitem" class="corporate-menu__list__item">
              <a tabindex="0" href="https://www.raiplay.it/dirette" target="_top" class="corporate-menu__list__item__link"
                >TV</a
              >
            </li>
            <li role="menuitem" class="corporate-menu__list__item">
              <a tabindex="0" href="https://www.raiplaysound.it" target="_top" class="corporate-menu__list__item__link"
                >RaiPlay Sound</a
              >
            </li>
            <li role="menuitem" class="corporate-menu__list__item">
              <a tabindex="0" href="https://www.rainews.it" target="_top" class="corporate-menu__list__item__link">News</a>
            </li>
            <li role="menuitem" class="corporate-menu__list__item">
              <a tabindex="0" href="https://www.raisport.it" target="_top" class="corporate-menu__list__item__link">Sport</a>
            </li>
            <li role="menuitem" class="corporate-menu__list__item">
              <a tabindex="0" href="https://www.raiplay.it/bambini/" target="_top" class="corporate-menu__list__item__link"
                >Bambini</a
              >
            </li>
            <li role="menuitem" class="corporate-menu__list__item">
              <a tabindex="0" href="https://www.raicultura.it" target="_top" class="corporate-menu__list__item__link"
                >Cultura</a
              >
            </li>
            <li role="menuitem" class="corporate-menu__list__item">
              <a tabindex="0" href="https://www.raiplay.it/learning/" target="_top" class="corporate-menu__list__item__link"
                >RaiPlayLearning</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="overlay-mask" @click=${this.toggleCorporateMenu}></div>
    `;
  }

  get corporateMenuBar() {
    return this.renderRoot.querySelector('#corporate-menu-bar');
  }

  get overlayMask() {
    return this.renderRoot.querySelector('.overlay-mask');
  }

  toggleCorporateMenu() {
    /** @type {HTMLElement} */
    const scrollingElement = this.ownerDocument.scrollingElement;
    if (this.corporateStatus === 'collapsed') {
      this.corporateStatus = 'expanding';
      this.overlayMask.style.visibility = 'visible';
      this.overlayMask.style.opacity = .9;
      scrollingElement.style.setProperty('overflow-y', 'hidden');
    } else {
      this.corporateStatus = 'collapsing';
      this.overlayMask.style.visibility = 'hidden';
      this.overlayMask.style.opacity = 0;
      scrollingElement.style.removeProperty('overflow-y');
    }
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'show-corporate-menu') {
      if (this.#lockedShowCorporateMenu) {
        // Ignora i cambiamenti successivi dell'attributo
        return;
      }
      super.attributeChangedCallback(name, oldVal, newVal);
      this.#lockedShowCorporateMenu = true;
      return;
    }
    super.attributeChangedCallback(name, oldVal, newVal);
  }
}
